/* URBAN V9: scroll controls time and atmospheric depth. No shopping mutations. */
(() => {
  'use strict';
  if (window.TZ_URBAN_CINEMA) return;
  window.TZ_URBAN_CINEMA = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const lowData = Boolean(navigator.connection?.saveData);
  const motionAllowed = () => !reduced.matches && !lowData;
  const clamp = n => Math.max(0, Math.min(1, n));
  const roots = [...document.querySelectorAll('[data-urban-cinema]')];
  const records = [];
  let raf = 0;

  function atmosphere(canvas, effect) {
    if (!canvas) return null;
    const gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, depth: false, powerPreference: 'low-power' });
    if (!gl) return null;
    const shader = (type, source) => {
      const s = gl.createShader(type); gl.shaderSource(s, source); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { gl.deleteShader(s); return null; }
      return s;
    };
    const vs = shader(gl.VERTEX_SHADER, 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}');
    const fs = shader(gl.FRAGMENT_SHADER, `precision mediump float;
      uniform vec2 size;uniform float progress;uniform float rain;
      float hash(vec3 p){p=fract(p*.3183099+vec3(.1,.2,.3));p*=17.;return fract(p.x*p.y*p.z*(p.x+p.y+p.z));}
      float noise(vec3 p){vec3 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(mix(hash(i),hash(i+vec3(1,0,0)),f.x),mix(hash(i+vec3(0,1,0)),hash(i+vec3(1,1,0)),f.x),f.y),mix(mix(hash(i+vec3(0,0,1)),hash(i+vec3(1,0,1)),f.x),mix(hash(i+vec3(0,1,1)),hash(i+vec3(1,1,1)),f.x),f.y),f.z);}
      void main(){vec2 uv=gl_FragCoord.xy/size;float t=progress*8.;float density=0.;
        if(rain>.5){for(int i=0;i<24;i++){float fi=float(i);float z=.5+hash(vec3(fi,2,1))*1.5;vec2 pos=vec2(fract(hash(vec3(fi,1,3))+t*.025/z),fract(hash(vec3(fi,6,2))-t*.48/z));vec2 d=uv-pos;d.x+=d.y*.17;float drop=exp(-pow(d.x*size.x/(.5+z),2.))*(1.-smoothstep(0.,.045/z,abs(d.y)));density+=drop*.3/z;}density*=1.-smoothstep(.18,.38,progress);}
        else{float reveal=smoothstep(.76,.94,progress);vec2 q=(uv-vec2(.5,.53))*vec2(size.x/size.y,1.);for(int i=0;i<14;i++){float z=float(i)/14.;vec3 p=vec3(q*6.,z*2.);p.x+=sin(p.y*4.-t+z*3.)*.12;p.y-=t*.19;float n=noise(p*3.4)+.5*noise(p*7.2);float width=.017+(uv.y-.45)*.065;float path=sin(uv.y*17.-t+z*4.)*.022;float plume=exp(-pow((q.x-path)/(max(.02,width)),2.));float vertical=smoothstep(.41,.56,uv.y)*(1.-smoothstep(.8,.98,uv.y));density+=max(0.,n-.67)*plume*vertical*.17;}density*=reveal*3.2;}
        gl_FragColor=vec4(.82,.91,.94,clamp(density,0.,.38));}`);
    if (!vs || !fs) return null;
    const program = gl.createProgram();gl.attachShader(program, vs);gl.attachShader(program, fs);gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
    const buf = gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER, buf);gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
    gl.useProgram(program);const loc=gl.getAttribLocation(program,'a');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
    const uSize=gl.getUniformLocation(program,'size'),uProgress=gl.getUniformLocation(program,'progress');gl.uniform1f(gl.getUniformLocation(program,'rain'),effect==='rain'?1:0);
    canvas.addEventListener('webglcontextlost', e => { e.preventDefault();canvas.hidden=true; });
    return p => {if(canvas.hidden)return;const r=canvas.getBoundingClientRect();const scale=Math.min(1,680/Math.max(r.width,r.height));const w=Math.max(1,Math.round(r.width*scale)),h=Math.max(1,Math.round(r.height*scale));if(canvas.width!==w||canvas.height!==h){canvas.width=w;canvas.height=h;}gl.viewport(0,0,w,h);gl.useProgram(program);gl.uniform2f(uSize,w,h);gl.uniform1f(uProgress,p);gl.drawArrays(gl.TRIANGLES,0,6);};
  }

  function moveRail(track, lines, progress, width, minOpacity) {
    if(!track || !lines.length)return;
    let position=0;
    for(let i=1;i<lines.length;i++){
      let blend=clamp((progress-lines[i].at+width)/(width*2));
      position+=blend*blend*(3-2*blend);
    }
    const lower=Math.floor(position),upper=Math.min(lines.length-1,lower+1),fraction=position-lower;
    const center=line=>line.el.offsetTop+line.el.offsetHeight/2;
    const offset=center(lines[lower])*(1-fraction)+center(lines[upper])*fraction;
    track.style.transform='translate3d(0,'+(-offset).toFixed(2)+'px,0)';
    lines.forEach((line,i)=>{
      const distance=Math.abs(i-position);
      line.el.style.opacity=String(distance<1?1-(1-minOpacity)*distance:Math.max(0,minOpacity-(distance-1)*.24));
      line.el.classList.toggle('is-highlighted',distance<.5);
    });
  }
  function lyrics(rec) {
    moveRail(rec.track,rec.lines,rec.progress,.045,.24);
    moveRail(rec.titleTrack,rec.titles,rec.progress,.065,.18);
  }

  function seek(rec) {
    const v=rec.video;
    if(rec.hero || !v || !Number.isFinite(v.duration) || v.readyState<1 || v.seeking || document.hidden || !motionAllowed())return;
    const target=rec.progress*Math.max(0,v.duration-.055);
    if(Math.abs(v.currentTime-target)>.06){try{v.currentTime=target;}catch{ /* Keep poster until metadata is ready. */ }}
  }
  function load(rec) {
    if(!rec.video || !motionAllowed())return;
    const v=rec.video;const src=mobile.matches&&v.dataset.mobile?v.dataset.mobile:v.dataset.desktop;
    if(!src || v.getAttribute('src')===src)return;
    rec.root.classList.remove('is-video-ready');v.muted=true;v.preload='auto';v.src=src;v.load();
  }
  function stop(rec){rec.video?.pause();}
  function draw(){
    raf=0;
    records.forEach(rec=>{
      const r=rec.root.getBoundingClientRect();rec.visible=r.bottom>0&&r.top<innerHeight;
      if(!rec.visible || document.hidden){stop(rec);return;}
      if(!motionAllowed())return;
      if(rec.hero){if(rec.video?.readyState>=2)rec.video.play().catch(()=>{});return;}
      const stageHeight=rec.stage.getBoundingClientRect().height;
      rec.progress=clamp(-r.top/Math.max(1,r.height-stageHeight));rec.root.dataset.progress=rec.progress.toFixed(4);
      const index=rec.messages.reduce((chosen,el,i)=>rec.progress>=Number(el.dataset.at||0)?i:chosen,0);
      rec.messages.forEach((el,i)=>{el.classList.toggle('is-current',i===index);el.setAttribute('aria-hidden',String(i!==index));el.inert=i!==index;});
      lyrics(rec);
      seek(rec);
      if(rec.canvas && !rec.depth)rec.depth=atmosphere(rec.canvas,rec.root.dataset.effect);
      rec.depth?.(rec.progress);
    });
  }
  function schedule(){if(!raf&&!document.hidden)raf=requestAnimationFrame(draw);}
  const near = new IntersectionObserver(entries=>entries.forEach(entry=>{const rec=records.find(r=>r.root===entry.target);if(!rec)return;rec.near=entry.isIntersecting;if(entry.isIntersecting)load(rec);else stop(rec);schedule();}),{rootMargin:'70% 0px'});
  roots.forEach(root=>{
    const rec={root,video:root.querySelector('video'),stage:root.querySelector('.uc-stage'),messages:[...root.querySelectorAll('[data-uc-message]')],canvas:root.querySelector('canvas'),hero:root.dataset.mode==='hero',progress:0,near:false};records.push(rec);
    rec.track=root.querySelector('.uc-lyric-track');
    rec.titleTrack=root.querySelector('.uc-title-track');
    rec.titles=rec.messages.map(el=>({el,at:Number(el.dataset.at||0)}));
    rec.lines=[...root.querySelectorAll('[data-lyric-at]')].map(el=>{
      const start=Number(el.dataset.lyricAt), next=rec.messages.map(m=>Number(m.dataset.at)).find(at=>at>start)??1;
      return {el,at:start+(next-start)*Number(el.dataset.part)/Number(el.dataset.parts)};
    });
    root.querySelectorAll('a').forEach(a=>a.classList.add('js-no-transition'));
    if(rec.video){
      rec.video.addEventListener('loadedmetadata',()=>{seek(rec);schedule();});
      rec.video.addEventListener('loadeddata',()=>{root.classList.add('is-video-ready');seek(rec);schedule();});
      rec.video.addEventListener('seeked',()=>seek(rec));
      rec.video.addEventListener('error',()=>root.classList.remove('is-video-ready'));
      if(rec.hero)rec.video.loop=true;
    }
    near.observe(root);
  });

  // Editorial films are deliberately short one-time previews with no extra controls.
  const loopRecords=[...document.querySelectorAll('[data-urban-loop]')].map(video=>({video,visible:false,done:false}));
  function playPreview(rec){if(!motionAllowed()||document.hidden||rec.done||!rec.visible)return;const v=rec.video;if(!v.getAttribute('src')){v.src=v.dataset.src;v.muted=true;v.load();}v.play().catch(()=>{});}
  const previews=new IntersectionObserver(entries=>entries.forEach(e=>{const rec=loopRecords.find(r=>r.video===e.target);if(!rec)return;rec.visible=e.isIntersecting&&e.intersectionRatio>.15;if(rec.visible)playPreview(rec);else rec.video.pause();}),{threshold:[0,.15]});
  loopRecords.forEach(rec=>{rec.video.addEventListener('timeupdate',()=>{if(rec.video.currentTime>=4.8){rec.done=true;rec.video.pause();}});rec.video.addEventListener('ended',()=>{rec.done=true;});previews.observe(rec.video);});

  // Reuse the existing guide markup; keep focus and panel ownership explicit.
  document.querySelectorAll('.ww--urban [data-guide]').forEach(guide=>{
    const tabs=[...guide.querySelectorAll('[role="tab"]')];
    const select=(n,focus)=>{tabs.forEach((tab,i)=>{const selected=i===n;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;const panel=document.getElementById(tab.getAttribute('aria-controls'));if(panel)panel.hidden=!selected;});if(focus)tabs[n].focus();schedule();};
    tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(i,false));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(n,true);}});});
  });
  function mode(){
    records.forEach(rec=>{stop(rec);rec.root.classList.toggle('is-scrub',!rec.hero&&motionAllowed());rec.root.dataset.motion=motionAllowed()?'scroll':'static';rec.messages.forEach(el=>{el.removeAttribute('aria-hidden');el.inert=false;el.style.removeProperty('opacity');});if(rec.canvas)rec.canvas.hidden=!motionAllowed();if(rec.near)load(rec);});
    loopRecords.forEach(rec=>{rec.video.pause();playPreview(rec);});schedule();
  }
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',()=>{records.filter(r=>r.near).forEach(load);schedule();},{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){records.forEach(stop);loopRecords.forEach(r=>r.video.pause());if(raf)cancelAnimationFrame(raf);raf=0;}else{loopRecords.forEach(playPreview);schedule();}});
  reduced.addEventListener('change',mode);new ResizeObserver(schedule).observe(document.body);mode();
})();
